import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import {
  media,
  Z_INDEX_OVERLAY,
} from '@savgroup-front-common/constants/shared';
import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { getModalSize, MODAL_SIZES } from './Modal.helpers';
import { ModalPosition } from './Modal.types';

interface $ModalContainerProps {
  $size: MODAL_SIZES;
}

export const $ModalContainer = styled.div<$ModalContainerProps>`
  z-index: ${Z_INDEX_OVERLAY};
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;

  justify-content: center;
  align-items: ${({ $size }) =>
    $size === MODAL_SIZES.SMALL ? 'center' : 'flex-start'};
  overflow-y: auto;

  @media ${media.minWidth.sm} {
    padding: ${spacing(12)} ${spacing('lg')};
  }

  overflow-x: hidden;
`;
export const $IconContainer = styled.div`
  position: absolute;
  user-select: none;
  pointer-events: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  border-radius: ${({ theme }) => theme.newUI.borders.bigRadius};

  svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 600px;
    height: 600px;
    color: ${({ theme }) => rgba(theme.colors.primary, 0.1)};
    transform: translate(20%, -20%) rotate(15deg);
  }
`;

interface $ModalAnimationContainerProps {
  $size: MODAL_SIZES;
  $transformOrigin: ModalPosition;
}

export const $ModalAnimationContainer = styled.div<$ModalAnimationContainerProps>`
  width: 100%;
  transform-origin: center center;

  @media ${media.minWidth.sm} {
    max-width: ${getModalSize};
  }
`;

interface $ModalBlockProps {
  shouldShowPadding: boolean;
  $size: MODAL_SIZES;
}
export const $ModalBlock = styled.div<$ModalBlockProps>`
  background: ${({ theme }) => theme.systemColors.defaultBackground};
  margin-top: ${({ $size }) =>
    $size === MODAL_SIZES.SMALL ? '0' : spacing('xl')};
  border-radius: ${({ theme }) => theme.newUI.borders.bigRadius};
  width: 100%;
  z-index: 2;
  pointer-events: auto;
  position: relative;
  transition-duration: 0.3s;
  @media ${media.minWidth.sm} {
    padding: ${({ shouldShowPadding }) =>
      shouldShowPadding ? `${spacing(10)} ${spacing(16)}` : 0};
  }
  @media ${media.maxWidth.sm} {
    padding: ${({ shouldShowPadding }) =>
      shouldShowPadding ? `${spacing(5)} !important` : 0};
    width: 100% !important;
  }
`;

export const $CloseIconWrapper = styled.button`
  position: absolute;
  top: calc(-1 * ${spacing(11)});
  height: ${spacing(11)};
  right: calc(-1 * ${spacing('xxl')});
  padding: 0 ${spacing('xxl')};
  cursor: pointer;
  background: transparent;
  outline: 0;
  border: none;
  color: white;

  > div {
    transition-duration: 0.2s;
    padding: ${spacing(1.5)};
    display: flex;
    align-items: center;
    border-radius: ${({ theme }) => theme.tw.radius.sm};
  }
  &:hover > div,
  &:focus > div {
    background: rgba(255, 255, 255, 0.3);
  }
  &:active > div {
    transform: scale(${({ theme }) => theme.interactions.activeScale});
  }

  svg {
    color: white;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;

  margin: 0 calc(-1 * ${spacing('xl')}) ${spacing('lg')} calc(-1 * ${spacing('xl')});
  padding: 0 ${spacing('xl')};
`;

export const ModalFooter = styled.footer`
  width: 100%;
  margin-top: ${spacing('lg')};

  @media ${media.maxWidth.xs} {
    ${Col}:not(:last-child) {
      margin-bottom: ${spacing('lg')};
    }
  }
  @media ${media.minWidth.sm} {
    margin-top: ${spacing(12)};
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
`;
